'use strict';

var _ = require('lodash');
var PricingDateChartGapsService = function PricingDateChartGapsService() {
  function buildGap(item, diff, dateProperty, propsToPick) {
    var props = propsToPick || [];
    var gapBarDate = item[dateProperty].add(diff, 'd');
    var gap = _.chain(item).pick(props).extend({
      isGap: true,
      runNumber: gapBarDate.format('YYYYMMDD') + '1'
    }).value();
    gap[dateProperty] = gapBarDate;
    return gap;
  }
  function getGapCount(nextItem, item, dateProperty) {
    return nextItem[dateProperty].diff(item[dateProperty], 'd') - 1;
  }
  function getGaps(item, nextItem, dateProperty, additionalProperties) {
    if (nextItem) {
      var gapsCount = getGapCount(nextItem, item, dateProperty);
      return _.times(gapsCount, function (index) {
        return buildGap(item, index + 1, dateProperty, additionalProperties);
      });
    }
  }
  function fillGaps(data, dateProperty, additionalProperties) {
    return _.chain(data).transform(function (result, item, index, inputData) {
      var nextItem = inputData[index + 1];
      var gaps = getGaps(item, nextItem, dateProperty, additionalProperties);
      result.push(item);
      result.push(gaps);
      return result;
    }).flatten().compact().value();
  }
  return {
    fillGaps: fillGaps
  };
};
PricingDateChartGapsService.$inject = [];
module.exports = PricingDateChartGapsService;